import angular from 'angular';
import DataCounterFactory from './datacounter.factory';

let dataCounterModule = angular.module('app.data-counter', [])

.factory('DataCounter', DataCounterFactory)

.name;

export default dataCounterModule;


// WEBPACK FOOTER //
// ./client/app/common/data-counter/index.js